import { render, staticRenderFns } from "./WishlistComponent.vue?vue&type=template&id=560ab05c"
import script from "./WishlistComponent.vue?vue&type=script&lang=js"
export * from "./WishlistComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports